import { render } from "./ReportsNavigation.vue?vue&type=template&id=0ed9f6ea&scoped=true"
import script from "./ReportsNavigation.vue?vue&type=script&lang=js"
export * from "./ReportsNavigation.vue?vue&type=script&lang=js"

import "./ReportsNavigation.vue?vue&type=style&index=0&id=0ed9f6ea&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed9f6ea"]])

export default __exports__